import axios from 'axios';
import * as THREE from "three";
import React, { useEffect } from 'react'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { GreyCheckbox, GreyRadio } from '../style/customUI';
import SideStyle from '../style/sideStyle';
//import Control from '../store/control';
import Param from '../store/param';
import Control from '../store/control';
import { Vpoints2Points } from "../shape/Adapter";
//import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
//import { POLLING_INTERVAL1 } from '../store/global';


// Modifying
const FormModify = () => {
  const style              = SideStyle();
  const setup              = Param.Get("setup");
  const align              = Param.Get("align");
  const marking            = Param.Get("marking");
  const modify             = Param.Get("modify");
  const setParam           = Param.Get("setParam");
  const setModifyPoints    = Param.Get("setModifyPoints");
  const clearModifyPoints  = Param.Get("clearModifyPoints");

  const setControl      = Control.Get('setControl');
  const meshSocketCompress = Control.Get("meshSocketCompress");
  const meshSocketCompressVtk = Control.Get("meshSocketCompressVtk");
  const meshSocketModifyVtk = Control.Get("meshSocketModifyVtk");
  const SetCameraBottom = Control.Get("SetCameraBottom");
  const SetCameraFront  = Control.Get("SetCameraFront");
  const SetCameraBack   = Control.Get("SetCameraBack");
  const SetCameraOut    = Control.Get("SetCameraOut");
  const SetCameraIn     = Control.Get("SetCameraIn");

  const target = Number(modify.target);

  useEffect(() => {
    SetCameraFront(0);
    setParam(s => {s.instructionText = "Modify the contours, push [Apply], and go to [Trimming]"});
  }, [])


  const apply = () => {
    if (process.env.REACT_APP_CALC_MODE == 0) { // local calculation
      setControl(s => {s.applyModify = true})
      setParam(s => {s.modify.step = 1})
      setParam(s => {s.modify.depthNow[modify.target] = Number(modify.depth[modify.target])}) // set selected area depth value

    } else if (process.env.REACT_APP_CALC_MODE == 1) { // server calculation
      const outerPoints = Vpoints2Points(modify.vptO[target]);
      const innerPoints = Vpoints2Points(modify.vptI[target]);

      // TODO: add multiple modify operation, so to send modify shape after once modified.
      var meshSocketVtk = null;
      if (meshSocketModifyVtk === null) {
        meshSocketVtk =  meshSocketCompressVtk; // first time
      } else {
        meshSocketVtk = meshSocketModifyVtk; // after second time
      }

      // axios settings
      const url  = process.env.REACT_APP_BACKEND_SERVER + "/api/modify";
      const data = {
        'socketVertices': meshSocketVtk.vertices,
        'socketFaces': meshSocketVtk.faces,
        'smooth': Number(modify.smooth[modify.target]),
        'depth': Number(modify.depth[modify.target]),
        'outerPoints': outerPoints,
        'innerPoints': innerPoints,
      };
      const header = {
        headers: {
          //'Content-Type': 'multipart/form-data'
          'Content-Type': 'application/json',
          //'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i+1, i+nFace+1);

            if (nFace==3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace==4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }
            i += nFace;
          }


          var temp = {
            vertices: res.data['socketVertices'],
            faces: res.data['socketFaces'],
          };
          console.log(temp)
          setControl(s => {s.meshSocketModifyVtk = temp});

          var temp = {
            vertices: vertices,
            faces: faces,
          };
          console.log(temp)
          setControl(s => {s.meshSocketModify = temp});
        }
      })
      .catch(err => {
        console.log('error');
      });
    }
  };

  const applyAll = () => {
    // set depth value
    for ( let i = 0; i < modify.depth.length; i++ ) {
      setParam( s => {s.modify.depthNow[i] = s.modify.depth[i]} );
    }
    setControl(s => {s.applyModify = true});
    setParam(s => {s.modify.step = 1});
  };
  
  const handleValue = (idx, e) => {
    if (e.target.name == 'smooth') {
      setParam( s => {s.modify[e.target.name][idx] = Number(e.target.value)});
    } else {
      setParam( s => {s.modify[e.target.name][idx] = e.target.value});
    }
  };

  const handleValueSmooth = (e) => {
    setParam(s => {s.modify[e.target.name] = Number(e.target.value)});
  };

  const handleValueDepth = (idx, e) => {
    setParam( s => {s.modify.depth[idx] = Number(e.target.value)});
    setParam( s => {s.modify.depthNow[idx] = Number(e.target.value)});
  };

  const onClickTarget = (e) => {
    setParam(s => {s.modify.target = e.currentTarget.value});
    setParam( s => {s.modify.depthNow[e.currentTarget.value] = Number(modify.depth[e.currentTarget.value])});

    // TODO: it could be better to move control founctions to outside form
    switch(Number(e.currentTarget.value)){
      case 0: //PTB
        SetCameraFront();
        break;
      case 1: //Counter
        SetCameraBack();
        break;
      case 2: //Tibia
        SetCameraFront();
        break;
      case 3: //Head of fibula
        SetCameraOut(setup.side);
        break;
      case 4: //Bottom of fibula
        SetCameraOut(setup.side);
        break;
    }
  };
  const onSmooth = () => {
    console.log(modify.iterationSmooth)
    console.log(modify.executeSmooth)
    setParam(s => {s.modify.executeSmooth += modify.iterationSmooth}); // count iteration number and trigger to execute
  };
  const onMove = () => {
    setParam(s => {s.modify.mode = 0});
  };
  const onDelete = () => {
    setParam(s => {s.modify.mode = 1});
  };
  const reset = () => {
    setModifyPoints(modify.target, null, null);
  };
  const resetAll = () => {
    clearModifyPoints();
  };
  const clearSocket = () => {
    clearModifyPoints();
    setControl(s => {s.meshSocketModify = s.meshSocketTrim});
    setParam(s => {s.modify.step = 0})
    // reset depth value
    for ( let i = 0; i < modify.depth.length; i++ ) {
      setParam( s => {s.modify.depthNow[i] = 0} );
    }
  };
  const skip = () => {
    setParam(s => {s.modify.step = 1})
  };

  function getActiveMode(val){
    return (modify.mode == val) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }
  function getActiveTarget(val){
    return (modify.target == val) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }
  // TODO: what is this function?????
  function getDisabled(target){
    return false;
    // switch(target){
    //   case 0:
    //     return !(align.vpt_ptbI && align.vpt_ptbI && marking.vpt[0] && marking.vpt[1]);
    //   case 1:
    //     return !(marking.vpt[0] && marking.vpt[1]);
    //   case 2:
    //     return !(marking.vpt[0] && marking.vpt[1] && marking.vpt[2]);
    //   default: //3-9
    //     return (marking.vpt[target] == null);
    //   }
    // return true; //never reach here!
  }

  const AreaSelect = (props) => {
    return (
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Button className={getActiveTarget(props.targetIdx)} onClick={onClickTarget} value={props.targetIdx} disabled={getDisabled(props.targetIdx)} size="small" >{props.areaName}</Button>
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="filled-number"
            name='depth'
            label={ props.targetIdx==0 ? "Depth" : "" }
            type="number"
            defaultValue={modify.depth[props.targetIdx]}
            fullWidth
            onChange={(e) => handleValueDepth(props.targetIdx, e)}
            InputProps={{
              endAdornment: <InputAdornment position="start" >mm</InputAdornment>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:-20, 
              max:20,
              step:1
            }}
          />
        </Grid>
        {/* <Grid item xs={3}>
          <TextField
            id="filled-number"
            name='smooth'
            label={ props.targetIdx==0 ? "Smooth" : "" }
            type="number"
            defaultValue={modify.smooth[props.targetIdx]}
            fullWidth
            onChange={(e) => handleValue(props.targetIdx, e)}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0, 
              max:10,
              step:1
            }}
          />
        </Grid> */}
      </Grid>
    )
  }

  return (
    <div className={style.outside}>
      <Grid item xs={12} className={style.subcategory}>Smoothing</Grid>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={9}>
          <TextField
            id="filled-number"
            name='iterationSmooth'
            label='Smooth Iteration'
            type='number'
            defaultValue={1}
            fullWidth
            onChange={(e) => handleValueSmooth(e)}
            InputProps={{
              endAdornment: <InputAdornment position="start" ></InputAdornment>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:1, 
              max:10,
              step:1
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Button className={style.button} onClick={onSmooth} size="small" >Execute</Button>
        </Grid>
      </Grid>


      <Grid item xs={12} className={style.subcategory}>Operation</Grid>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Button className={getActiveMode(0)} onClick={onMove} size="small" >Move/Create point</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={getActiveMode(1)} onClick={onDelete} size="small" >Delete point</Button>
        </Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Button className={style.button} onClick={reset} size="small" >Reset Area</Button>
        </Grid>
        {/* <Grid item xs={4}>
          <Button className={style.button} onClick={resetAll} size="small" >Reset All Area</Button>
        </Grid> */}
        <Grid item xs={6}>
          <Button className={style.button} onClick={clearSocket} disabled={(modify.step==0)} size="small" >Clear Socket</Button>
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center'>
        {/* <Grid item xs={4}>
          <Button className={style.button} onClick={skip} size="small" >Skip</Button>
        </Grid> */}
        <Grid item xs={6}>
          <Button className={style.button} onClick={apply} size="small" >Apply</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={style.button} onClick={applyAll} size="small" >Apply All</Button>
        </Grid>
      </Grid>

      <Grid item xs={12} className={style.subcategory}>Area</Grid>
      <AreaSelect targetIdx={0} areaName="PTB"/>
      <AreaSelect targetIdx={1} areaName="Counter"/>
      <AreaSelect targetIdx={2} areaName="Tibia"/>
      <AreaSelect targetIdx={3} areaName="Head of Fibura"/>
      <AreaSelect targetIdx={4} areaName="End of Fibura"/>
      <AreaSelect targetIdx={5} areaName="User 1"/>
      <AreaSelect targetIdx={6} areaName="User 2"/>
      <AreaSelect targetIdx={7} areaName="User 3"/>
      <AreaSelect targetIdx={8} areaName="User 4"/>
      <AreaSelect targetIdx={9} areaName="User 5"/>
    </div>
  );
}

export default FormModify;
